import axios from "axios";
import { ForgotPasswordFormData, ForgotPasswordResponse } from "./types";
import apiClient from "@/core/api/apiClient";
import { ENDPOINTS } from "@/core/api/apiClient";

/**
 * Submits the forgot password form to the API
 * @param formData The email for password reset
 * @returns Promise with the response data
 */
export const submitForgotPasswordForm = async (
  formData: ForgotPasswordFormData
): Promise<ForgotPasswordResponse> => {
  try {
    const response = await apiClient.post(ENDPOINTS.FORGOT_PASSWORD, {
      email: formData.email,
    });

    if (response.status === 200) {
      return {
        success: true,
        message:
          "Password reset instructions have been sent to your email address.",
      };
    } else {
      return {
        success: false,
        message: "Failed to process your request. Please try again later.",
      };
    }
  } catch (error) {
    console.error("Forgot password submission error:", error);

    if (axios.isAxiosError(error)) {
      const status = error.response?.status;

      // User not found
      if (status === 404) {
        return {
          success: false,
          message: "No account found with that email address.",
        };
      }

      // Too many requests
      if (status === 429) {
        return {
          success: false,
          message: "Too many attempts. Please try again later.",
        };
      }

      // Other API errors
      if (error.response?.data?.message) {
        return {
          success: false,
          message: error.response.data.message,
        };
      }
    }

    // Generic error
    return {
      success: false,
      message:
        "We're experiencing technical difficulties. Please try again later.",
    };
  }
};
